







































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, FormItem, Input } from 'element-ui';

// types
import {
  ShipmentDocumentDataInput,
  ShipmentDocumentFields
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    'el-button': Button,
    'el-form-item': FormItem,
    'el-input': Input
  }
})
export default class ContactInformation extends Vue {
  @Prop({ type: Object }) value!: ShipmentDocumentDataInput;
  @Prop({ type: Object }) document!: ShipmentDocumentFields;
  @Prop({ default: 3, type: Number }) cols!: number;

  get shipmentShipperName() {
    return this.value.shipmentShipperName;
  }

  set shipmentShipperName(data) {
    this.$emit('input', { ...this.value, shipmentShipperName: data });
  }

  get shipmentShipperAddress() {
    return this.value.shipmentShipperAddress;
  }

  set shipmentShipperAddress(data) {
    this.$emit('input', { ...this.value, shipmentShipperAddress: data });
  }

  get shipmentShipperEmail() {
    return this.value.shipmentShipperEmail;
  }

  set shipmentShipperEmail(data) {
    this.$emit('input', { ...this.value, shipmentShipperEmail: data });
  }

  get shipmentShipperPhone() {
    return this.value.shipmentShipperPhone;
  }

  set shipmentShipperPhone(data) {
    this.$emit('input', { ...this.value, shipmentShipperPhone: data });
  }

  get shipmentConsigneeName() {
    return this.value.shipmentConsigneeName;
  }

  set shipmentConsigneeName(data) {
    this.$emit('input', { ...this.value, shipmentConsigneeName: data });
  }

  get shipmentConsigneeAddress() {
    return this.value.shipmentConsigneeAddress;
  }

  set shipmentConsigneeAddress(data) {
    this.$emit('input', { ...this.value, shipmentConsigneeAddress: data });
  }

  get shipmentConsigneeEmail() {
    return this.value.shipmentConsigneeEmail;
  }

  set shipmentConsigneeEmail(data) {
    this.$emit('input', { ...this.value, shipmentConsigneeEmail: data });
  }

  get shipmentConsigneePhone() {
    return this.value.shipmentConsigneePhone;
  }

  set shipmentConsigneePhone(data) {
    this.$emit('input', { ...this.value, shipmentConsigneePhone: data });
  }

  get shipmentNotifyName() {
    return this.value.shipmentNotifyName;
  }

  set shipmentNotifyName(data) {
    this.$emit('input', { ...this.value, shipmentNotifyName: data });
  }

  get shipmentNotifyAddress() {
    return this.value.shipmentNotifyAddress;
  }

  set shipmentNotifyAddress(data) {
    this.$emit('input', { ...this.value, shipmentNotifyAddress: data });
  }

  get shipmentNotifyEmail() {
    return this.value.shipmentNotifyEmail;
  }

  set shipmentNotifyEmail(data) {
    this.$emit('input', { ...this.value, shipmentNotifyEmail: data });
  }

  get shipmentNotifyPhone() {
    return this.value.shipmentNotifyPhone;
  }

  set shipmentNotifyPhone(data) {
    this.$emit('input', { ...this.value, shipmentNotifyPhone: data });
  }

  copyToNotify() {
    // emit consignee values to copy the data
    this.$emit('input', {
      ...this.value,
      shipmentNotifyName: this.shipmentConsigneeName,
      shipmentNotifyAddress: this.shipmentConsigneeAddress,
      shipmentNotifyEmail: this.shipmentConsigneeEmail,
      shipmentNotifyPhone: this.shipmentConsigneePhone
    });
  }
}
